<template>
  <div class="w-full bg-white sticky top-0 z-50 shadow-lowerHeader">
    <div class="container mx-auto max-w-custom flex justify-between items-center p-[5px] relative">
      <!-- MList Button on the Left -->
      <MList :headers="combinedHeaders" v-if="$userStore.user" />

      <!-- Centered Logo -->
      <router-link to="/home" class="flex items-center mx-auto">
        <HeaderLogo class="w-[150px] h-[40px]" />
      </router-link>

      <!-- Language Selector on the Right -->
      <LanguageSelector class="flex items-center" />
    </div>
  </div>
</template>

<script>
import HeaderLogo from "@/Header/HeaderLogo.vue";
import MList from "@/Header/Mobile/MList.vue";
import LanguageSelector from "@/Header/Desktop/LanguageSelector.vue";

export default {
  name: "MHeader",
  props: {
    headers: {
      type: Object,
      required: true,
    },
  },
  components: {
    HeaderLogo,
    MList,
    LanguageSelector,
  },
  computed: {
    combinedHeaders() {
      // Combine upper and lower headers into a single array
      return [...this.headers.upper, ...this.headers.lower];
    },
  },
};
</script>